<template>
  <section class="da-filtros">
    <div class="da-filtros__row da-filtros__row--main">
      <div
        v-if="showStoreSelect"
        class="da-filtros__field da-filtros__field--loja"
      >
        <div class="da-filtros__loja-head">
          <label
            class="da-filtros__label da-filtros__label--loja mb-0"
            for="da-filtros-select-loja"
          >Loja</label>
          <span class="da-filtros__loja-hint">clique para trocar</span>
        </div>
        <div
          class="da-filtros__select-shell"
          :class="{ 'da-filtros__select-shell--disabled': carregando }"
          title="Clique para escolher outra loja"
        >
          <b-form-select
            id="da-filtros-select-loja"
            :value="chatSelecionado"
            :options="storeOptions"
            class="da-filtros__select"
            :disabled="carregando"
            aria-describedby="da-filtros-loja-desc"
            @input="onLoja"
          />
          <span
            id="da-filtros-loja-desc"
            class="sr-only"
          >Lista suspensa. Use para alterar a loja e atualizar os dados.</span>
          <div
            class="da-filtros__select-affordance"
            aria-hidden="true"
          >
            <feather-icon
              icon="ChevronDownIcon"
              size="22"
              class="da-filtros__select-chevron"
            />
          </div>
        </div>
      </div>

      <div class="da-filtros__periodo-wrap">
        <div class="da-filtros__periodo-panel">
          <div class="da-filtros__periodo-head">
            <span class="da-filtros__periodo-title">Período</span>
            <span class="da-filtros__req">obrigatório</span>
          </div>

          <div class="da-filtros__presets">
            <button
              v-for="p in presets"
              :key="p.dias"
              type="button"
              class="da-filtros__chip"
              :class="{ 'da-filtros__chip--active': atalhoDias === p.dias }"
              :disabled="carregando"
              @click="$emit('preset', p.dias)"
            >
              {{ p.label }}
            </button>
            <button
              type="button"
              class="da-filtros__chip"
              :class="{ 'da-filtros__chip--active': atalhoDias === null }"
              :disabled="carregando"
              @click="$emit('personalizado')"
            >
              Personalizado
            </button>
          </div>

          <div class="da-filtros__datas">
            <div class="da-filtros__field da-filtros__field--data">
              <label class="da-filtros__label da-filtros__label--mini">Data inicial</label>
              <b-form-datepicker
                :value="periodoInicio"
                locale="pt-BR"
                :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                class="da-filtros__datepicker w-100"
                menu-class="da-datepicker-popover"
                :disabled="carregando"
                :state="null"
                @input="v => $emit('update:periodoInicio', v)"
              />
            </div>
            <span
              class="da-filtros__datas-sep"
              aria-hidden="true"
            >→</span>
            <div class="da-filtros__field da-filtros__field--data">
              <label class="da-filtros__label da-filtros__label--mini">Data final</label>
              <b-form-datepicker
                :value="periodoFim"
                locale="pt-BR"
                :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                class="da-filtros__datepicker w-100"
                menu-class="da-datepicker-popover"
                :disabled="carregando"
                :state="null"
                @input="v => $emit('update:periodoFim', v)"
              />
            </div>
          </div>

          <div class="da-filtros__actions">
            <button
              type="button"
              class="da-filtros__btn da-filtros__btn--primary da-filtros__btn--full"
              :disabled="carregando"
              @click="$emit('aplicar')"
            >
              <b-spinner
                v-if="carregando"
                small
                class="mr-1"
              />
              Aplicar período
            </button>
          </div>
        </div>
      </div>

      <div class="da-filtros__toggle-col">
        <label class="da-filtros__label">Horário de atendimento</label>
        <div class="da-filtros__switch-row">
          <b-form-checkbox
            :checked="considerarHorario"
            switch
            :disabled="!temHorario || carregando"
            class="da-filtros__switch mb-0"
            @input="v => $emit('update:considerarHorario', v)"
          >
            Considerar apenas horário de atendimento
          </b-form-checkbox>
        </div>
        <p class="da-filtros__hint">
          <template v-if="temHorario">
            Métricas de tempo usam só minutos dentro do expediente configurado no período selecionado.
          </template>
          <template v-else>
            Disponível quando a loja tiver
            <router-link
              :to="rotaConfiguracaoChat"
              class="da-filtros__inline-link"
            >horário configurado</router-link>.
          </template>
        </p>
        <p
          v-if="considerarHorario && textoHorario"
          class="da-filtros__horario"
        >
          {{ textoHorario }}
        </p>
      </div>
    </div>
    <p class="da-filtros__footnote">
      Todas as métricas abaixo refletem exclusivamente o intervalo acima (máx. 31 dias), comparadas ao período anterior equivalente quando indicado.
    </p>
  </section>
</template>

<script>
export default {
  name: 'FiltrosDesempenhoAtendentes',
  props: {
    showStoreSelect: {
      type: Boolean,
      default: true,
    },
    storeOptions: {
      type: Array,
      default: () => [],
    },
    chatSelecionado: {
      type: [String, Number],
      default: null,
    },
    periodoInicio: {
      type: [Date, String],
      default: null,
    },
    periodoFim: {
      type: [Date, String],
      default: null,
    },
    atalhoDias: {
      type: Number,
      default: null,
    },
    considerarHorario: {
      type: Boolean,
      default: false,
    },
    temHorario: {
      type: Boolean,
      default: false,
    },
    textoHorario: {
      type: String,
      default: '',
    },
    carregando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      presets: [
        { dias: 7, label: 'Últimos 7 dias' },
        { dias: 15, label: 'Últimos 15 dias' },
        { dias: 31, label: 'Últimos 31 dias' },
      ],
    }
  },
  computed: {
    rotaConfiguracaoChat() {
      if (this.chatSelecionado) {
        return {
          name: 'chat-configuracao-central',
          params: { uuid: this.chatSelecionado },
        }
      }
      return { name: 'chat-configuracao-central' }
    },
  },
  methods: {
    onLoja(v) {
      const anterior = this.chatSelecionado
      this.$emit('update:chatSelecionado', v)
      /* Evita segundo carregarDados no mount quando o pai já define a loja e o select replica o valor. */
      if (String(v ?? '') !== String(anterior ?? '')) {
        this.$emit('change-loja')
      }
    },
  },
}
</script>

<style scoped>
.da-filtros {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(80, 45, 120, 0.08);
  border: 1px solid #e9dff5;
  padding: 28px 30px;
  margin-bottom: 28px;
  overflow: visible;
}

.da-filtros__row--main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem 2rem;
}

.da-filtros__field {
  flex: 1;
  min-width: 160px;
}

.da-filtros__field--loja {
  flex: 0 1 280px;
  min-width: 220px;
}

.da-filtros__loja-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.45rem;
}

.da-filtros__label--loja {
  margin-bottom: 0 !important;
}

.da-filtros__loja-hint {
  font-size: 0.68rem;
  font-weight: 600;
  color: #8a46e8;
  white-space: nowrap;
}

.da-filtros__select-shell {
  position: relative;
}

.da-filtros__select-shell--disabled .da-filtros__select-affordance {
  opacity: 0.4;
}

.da-filtros__select-affordance {
  position: absolute;
  right: 2px;
  top: 2px;
  bottom: 2px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: linear-gradient(90deg, transparent 0%, #fcfafe 28%);
  border-radius: 0 12px 12px 0;
}

.da-filtros__select-chevron {
  color: #6f35d0 !important;
  flex-shrink: 0;
}

.da-filtros__periodo-wrap {
  flex: 2 1 380px;
  min-width: 280px;
  position: relative;
  z-index: 1;
}

.da-filtros__periodo-panel {
  background: linear-gradient(180deg, #fbf8fe 0%, #fff 48%);
  border: 1px solid #ebe3f5;
  border-radius: 20px;
  padding: 1.15rem 1.25rem 1.25rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.da-filtros__periodo-head {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.da-filtros__periodo-title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #5e2bb8;
}

.da-filtros__toggle-col {
  flex: 1 1 260px;
  min-width: 220px;
}

.da-filtros__label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #7a7294;
  margin-bottom: 0.45rem;
}

.da-filtros__label--mini {
  font-size: 0.68rem;
  color: #8c84a3;
}

.da-filtros__req {
  font-size: 0.72rem;
  font-weight: 600;
  color: #8a46e8;
  text-transform: lowercase;
  letter-spacing: 0;
}

/* Só o controle fechado (~50px); NÃO usar >>> .form-control — a grade do calendário também tem .form-control */
.da-filtros__datepicker.b-form-btn-label-control.form-control {
  height: 50px !important;
  min-height: 50px !important;
  max-height: 50px !important;
  border-radius: 14px !important;
  background: #fcfafe !important;
  border: 1px solid #e9dff5 !important;
  padding: 0 !important;
  font-size: 0.95rem;
  color: #3c315b;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: visible !important;
}

.da-filtros__datepicker.b-form-btn-label-control.form-control:focus-within {
  border-color: #8a46e8 !important;
  box-shadow: 0 0 0 4px rgba(138, 70, 232, 0.1) !important;
}

.da-filtros__datepicker >>> label.form-control {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  height: 100% !important;
  min-height: 0 !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 0.75rem !important;
  font-weight: 600;
  border-radius: 0 14px 14px 0 !important;
}

/* Botão do calendário fica à esquerda (BootstrapVue) */
.da-filtros__datepicker >>> .btn {
  border-radius: 14px 0 0 14px !important;
  border: none !important;
  border-right: 1px solid #e9dff5 !important;
  background: #f3ecf9 !important;
  color: #6f35d0 !important;
  padding: 0 0.85rem !important;
}

.da-filtros__datepicker >>> .btn:hover,
.da-filtros__datepicker >>> .btn:focus {
  background: #e8dcf5 !important;
  color: #5e2bb8 !important;
}

/* Calendário dentro do menu: devolve altura automática */
.da-filtros__datepicker >>> .dropdown-menu .form-control {
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
}

.da-filtros__select-shell >>> select.custom-select,
.da-filtros__select-shell >>> select.form-control {
  height: 50px !important;
  min-height: 50px;
  border-radius: 14px !important;
  background: #fcfafe !important;
  border: 1px solid #e9dff5 !important;
  font-size: 0.95rem;
  font-weight: 600;
  color: #3c315b;
  padding-right: 3rem !important;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none !important;
}

.da-filtros__select-shell >>> select.custom-select:focus,
.da-filtros__select-shell >>> select.form-control:focus {
  border-color: #8a46e8 !important;
  box-shadow: 0 0 0 4px rgba(138, 70, 232, 0.1) !important;
}

.da-filtros__select-shell >>> select:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.da-filtros__presets {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 1rem;
}

.da-filtros__chip {
  border: 1px solid #e4daf0;
  background: #fff;
  color: #3c315b;
  border-radius: 999px;
  padding: 0.42rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(80, 45, 120, 0.04);
}

.da-filtros__chip:hover:not(:disabled) {
  border-color: #c9b8e0;
  background: #fffdff;
}

.da-filtros__chip--active {
  background: linear-gradient(135deg, #6f35d0, #8a46e8);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 6px 16px rgba(111, 53, 208, 0.28);
}

.da-filtros__chip:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.da-filtros__datas {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.65rem 0.75rem;
  margin-bottom: 1rem;
}

.da-filtros__field--data {
  flex: 1 1 140px;
  min-width: 140px;
  margin-bottom: 0;
}

.da-filtros__datas-sep {
  color: #c4b6dc;
  font-weight: 800;
  font-size: 1.1rem;
  padding-bottom: 0.65rem;
  flex: 0 0 auto;
}

.da-filtros__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.da-filtros__btn {
  border-radius: 14px;
  padding: 0.62rem 1.35rem;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.22s ease;
  border: none;
}

.da-filtros__btn--primary {
  background: linear-gradient(135deg, #6f35d0, #9b4dd4);
  color: #fff;
  box-shadow: 0 6px 18px rgba(111, 53, 208, 0.28);
}

.da-filtros__btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(111, 53, 208, 0.35);
}

.da-filtros__btn--full {
  width: 100%;
}

.da-filtros__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.da-filtros__switch-row {
  margin-top: 0.15rem;
}

.da-filtros__switch >>> .custom-control-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: #3c315b;
  line-height: 1.4;
}

.da-filtros__hint {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: #8c84a3;
  line-height: 1.45;
}

.da-filtros__inline-link {
  font-weight: 700;
  color: #6f35d0 !important;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.da-filtros__inline-link:hover {
  color: #8a46e8 !important;
}

.da-filtros__horario {
  margin: 0.65rem 0 0;
  font-size: 0.78rem;
  color: #6f6787;
  line-height: 1.4;
  padding: 0.5rem 0.65rem;
  background: #f7f2fc;
  border-radius: 12px;
  border: 1px solid #e9dff5;
}

.da-filtros__footnote {
  margin: 1.25rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid #efe8f7;
  font-size: 0.8rem;
  color: #8c84a3;
  line-height: 1.45;
}

@media (max-width: 767px) {
  .da-filtros {
    padding: 22px 18px;
  }

  .da-filtros__datas-sep {
    display: none;
  }
}
</style>

<!-- Popover do datepicker: z-index e espaço (classe aplicada via prop menu-class) -->
<style lang="scss">
.da-datepicker-popover.dropdown-menu {
  z-index: 2505 !important;
  min-width: 288px;
  padding: 0.4rem;
  border-radius: 18px !important;
  border: 1px solid #e9dff5 !important;
  box-shadow: 0 16px 48px rgba(80, 45, 120, 0.18) !important;
}

.da-datepicker-popover .b-calendar-grid.form-control {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
}

.da-datepicker-popover .b-calendar-header output,
.da-datepicker-popover .b-calendar-header .form-control {
  height: auto !important;
  min-height: auto !important;
}
</style>
